import { createAsyncThunk } from "@reduxjs/toolkit";
import { loadingActions } from "../LoaderSlice";
import { modalActions } from "../ModalSlice";
import { JEDI_HR_URL } from "../../constants";
import axios from "axios";
import axiosClient from "../../utils/axiosClient";

export const createChangeRequest = createAsyncThunk(
  "request/create_change_request",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside createChangeRequest : ", payload);

    const baseURL = "https://" + JEDI_HR_URL;

    const path = "/create_change_request";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);

      dispatch(loadingActions.setLoading(false));
      console.log("createChangeRequest response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message: response?.data?.message || response?.data?.error_message,
            status: "error",
            state: true,
          })
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error createChangeRequest : ", error.message);

      dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        })
      );
      return rejectWithValue(error);
    }
  }
);

export const getAllChangeRequests = createAsyncThunk(
  "request/get_all_change_request",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside getAllChangeRequests : ", payload);

    const baseURL = "https://" + JEDI_HR_URL;

    const path = "/get_all_change_request";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);

      dispatch(loadingActions.setLoading(false));
      console.log("getAllChangeRequests response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error : " +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          })
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error getAllChangeRequests : ", error.message);

      dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        })
      );
      return rejectWithValue(error);
    }
  }
);

export const getAllReportees = createAsyncThunk(
  "request/get_reportees",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    // dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside getAllReportees : ", payload);

    const baseURL = "https://" + JEDI_HR_URL;

    const path = "/get_reportees";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);

      // dispatch(loadingActions.setLoading(false));
      console.log("getAllReportees response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error : " +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          })
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error getAllReportees : ", error.message);

      // dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        })
      );
      return rejectWithValue(error);
    }
  }
);

export const generatePresignedURL = createAsyncThunk(
  "request/generate_presigned_url",
  async (data, { dispatch, getState, rejectWithValue }) => {
    let payload = data.payload;
    let file = data.file;

    dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside getPresignedURL : ", payload);

    const baseURL = "https://" + JEDI_HR_URL;

    const path = "/generate_presigned_url";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);

      // dispatch(loadingActions.setLoading(false));
      console.log("getPresignedURL response : ", response.data);

      if (response.data.status === "error") {
        dispatch(loadingActions.setLoading(false));
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error : " +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          })
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message
        );
      } else if (response.data?.status === "success") {
        const presigned_url = response.data?.presigned_url?.url;

        const formData = new FormData();

        Object.entries(response.data?.presigned_url?.fields).forEach(
          ([key, value]) => {
            formData.append(key, value);
          }
        );

        formData.append("file", file);

        console.log("\n\n\n\nFormdata : ", formData);

        try {
          const uploadResponse = await axios.post(
            presigned_url,
            formData
            // {
            //     headers: { "Content-Type": "multipart/form-data" },
            // }
          );

          console.log("upload ", uploadResponse);

          dispatch(loadingActions.setLoading(false));

          if (uploadResponse.status === 204) {
            console.log("File uploaded successfully!");
            // this is just for the bulk upload
            if (payload.key == "bulk_upload") {
              const newPayload = {
                key: response.data?.presigned_url?.fields?.key,
              };
              console.log("\n\nInside bulk_upload : ", newPayload);
              const baseURL = "https://" + JEDI_HR_URL;

              const path = "/upload_bulk_user_template";
              const url = baseURL + path;

              try {
                const response = await axiosClient.post(url, newPayload);
                console.log("bulk_upload response", response);
                dispatch(loadingActions.setLoading(false));
                if (response.data.status === "success") {
                  dispatch(
                    modalActions.setErrorModal({
                      message: response.data?.message,
                      status: "success",
                      state: true,
                      url: response?.data?.url,
                    })
                  );
                } else if (response.data.status === "error") {
                  dispatch(
                    modalActions.setErrorModal({
                      message:
                        "Error : " +
                        (response?.data?.message ||
                          response?.data?.error_message),
                      status: "error",
                      state: true,
                      details: response?.data?.details || [],
                      url: response?.data?.url,
                    })
                  );
                  return rejectWithValue(
                    response?.data?.error_message || response?.data?.message
                  );
                }
                return response.data;
              } catch (error) {
                console.log("Error getAllReportees : ", error.message);

                dispatch(loadingActions.setLoading(false));
                dispatch(
                  modalActions.setErrorModal({
                    message: error?.message,
                    status: error.status,
                    state: true,
                  })
                );
                return rejectWithValue(error);
              }
            }
          } else {
            console.error("Upload failed:", uploadResponse);
            return rejectWithValue(
              uploadResponse?.data?.error_message ||
                uploadResponse?.data?.message
            );
          }
        } catch (error) {
          console.error("Error uploading file:", error);
          dispatch(loadingActions.setLoading(false));
          dispatch(
            modalActions.setErrorModal({
              message: error?.message,
              status: error.status,
              state: true,
            })
          );
        }
        return response.data;
      }
    } catch (error) {
      console.log("Error get_presigned_url : ", error.message);

      dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        })
      );
      return rejectWithValue(error);
    }
  }
);

export const getAllLocs = createAsyncThunk(
  "request/get_all_loc",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside getAllLocs : ", payload);

    const baseURL = "https://" + JEDI_HR_URL;

    const path = "/get_all_loc";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);

      dispatch(loadingActions.setLoading(false));
      console.log("getAllLocs response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error : " +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          })
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error getAllLocs : ", error.message);

      dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        })
      );
      return rejectWithValue(error);
    }
  }
);
